export const environment: [number, number][] = [
  [5.577196797166618, 1.207305772636392],
  [6.177197178636344, 1.1073053911666655],
  [6.977196415696891, 1.1073053911666655],
  [7.177197178636344, 1.8073042467574858],
  [7.877197941575798, 2.007305009696939],
  [7.477196415696891, 2.507305009696939],
  [7.077194889817985, 3.007305009696939],
  [6.477196415696891, 3.007305009696939],
  [6.777195652757438, 2.4073046282272124],
  [6.477196415696891, 1.8073042467574858],
  [6.077196797166618, 2.507305009696939],
  [5.477196415696891, 3.007305009696939],
  [5.377196034227165, 2.307304246757486],
  [5.777195652757438, 1.9073046282272124],
  [5.177197178636344, 1.707305772636392],
  [4.577196797166618, 1.507305009696939],
  [4.977196415696891, 1.007305009696939],
  [4.377196034227165, 0.8073042467574858],
  [3.9771964156968913, 1.3073042467574858],
  [3.6771971786363444, 1.707305772636392],
  [3.277195652757438, 1.207305772636392],
  [2.777195652757438, 0.9073046282272124],
  [2.077196797166618, 1.007305009696939],
  [1.3771960342271647, 1.207305772636392],
  [0.6771971786363444, 1.507305009696939],
  [0.07719679716661787, 2.1073053911666655],
  [-0.22280434724256182, 1.507305009696939],
  [0.17719717863634443, 0.9073046282272124],
  [-0.42280320283338213, 0.3073042467574858],
  [-0.8228028213636556, -0.1926957532425142],
  [-1.0228035843031087, -0.792694227363608],
  [-1.4228032028333821, -0.1926957532425142],
  [-1.8228028213636556, 0.3073042467574858],
  [-1.1228039657728353, 0.40730462822721236],
  [-0.6228039657728353, 0.9073046282272124],
  [-1.3228028213636556, 1.1073053911666655],
  [-0.9228032028333821, 1.6073053911666655],
  [-0.6228039657728353, 2.1073053911666655],
  [-0.9228032028333821, 2.707305772636392],
  [-0.32280282136365557, 2.707305772636392],
  [-0.12280396577283526, 3.307304246757486],
  [0.4771964156968913, 3.4073046282272124],
  [0.8771960342271647, 3.807304246757486],
  [1.4771964156968913, 3.507305009696939],
  [1.9771964156968913, 3.207305772636392],
  [1.3771960342271647, 4.207305772636392],
  [1.9771964156968913, 3.9073046282272124],
  [2.4771964156968913, 3.6073053911666655],
  [3.077196797166618, 3.307304246757486],
  [2.577196797166618, 2.9073046282272124],
  [2.077196797166618, 2.507305009696939],
  [1.4771964156968913, 2.707305772636392],
  [0.9771964156968913, 3.007305009696939],
  [0.37719603422716474, 2.807304246757486],
  [0.8771960342271647, 2.307304246757486],
  [1.4771964156968913, 2.007305009696939],
  [2.077196797166618, 1.707305772636392],
  [2.6771971786363444, 1.507305009696939],
  [3.077196797166618, 1.9073046282272124],
  [2.577196797166618, 2.207305772636392],
  [3.077196797166618, 2.6073053911666655],
  [3.6771971786363444, 2.4073046282272124],
  [4.177197178636344, 2.007305009696939],
  [4.777195652757438, 2.207305772636392],
  [4.277195652757438, 2.707305772636392],
  [3.6771971786363444, 3.007305009696939],
  [4.177197178636344, 3.4073046282272124],
  [4.877196034227165, 2.707305772636392],
  [4.877196034227165, 3.307304246757486],
  [5.377196034227165, 3.707305772636392],
  [5.977196415696891, 3.307304246757486],
  [6.077196797166618, 3.9073046282272124],
  [6.677197178636344, 4.307304246757486],
  [6.677197178636344, 3.6073053911666655],
  [7.277195652757438, 3.507305009696939],
  [7.277195652757438, 4.1073053911666655],
  [7.277195652757438, 4.707305772636392],
  [6.677197178636344, 5.007305009696939],
  [6.077196797166618, 4.6073053911666655],
  [5.577196797166618, 4.307304246757486],
  [4.977196415696891, 4.507305009696939],
  [4.677197178636344, 3.9073046282272124],
  [4.077196797166618, 4.1073053911666655],
  [3.577196797166618, 3.707305772636392],
  [3.077196797166618, 4.1073053911666655],
  [3.577196797166618, 4.507305009696939],
  [4.077196797166618, 5.207305772636392],
  [4.377196034227165, 4.6073053911666655],
  [4.777195652757438, 5.207305772636392],
  [4.477196415696891, 5.807304246757486],
  [4.877196034227165, 6.407304628227212],
  [3.9771964156968913, 6.407304628227212],
  [3.6771971786363444, 5.807304246757486],
  [3.3771960342271647, 5.207305772636392],
  [2.8771960342271647, 4.807304246757486],
  [2.4771964156968913, 4.307304246757486],
  [1.8771960342271647, 4.6073053911666655],
  [1.1771971786363444, 4.807304246757486],
  [1.1771971786363444, 5.907304628227212],
  [0.7771956527574382, 5.407304628227212],
  [0.37719603422716474, 4.907304628227212],
  [0.6771971786363444, 4.307304246757486],
  [0.2771956527574382, 3.9073046282272124],
  [-0.022803584303108693, 4.407304628227212],
  [-0.32280282136365557, 5.007305009696939],
  [0.07719679716661787, 5.507305009696939],
  [0.4771964156968913, 6.007305009696939],
  [0.8771960342271647, 6.6073053911666655],
  [0.4771964156968913, 7.207304818962076],
  [1.2771956527574382, 7.1073053911666655],
  [1.6771971786363444, 6.407304628227212],
  [1.8771960342271647, 7.007305009696939],
  [2.577196797166618, 7.007305009696939],
  [2.3771960342271647, 6.307304246757486],
  [2.077196797166618, 5.807304246757486],
  [1.5771967971666179, 5.307304246757486],
  [2.3771960342271647, 5.1073053911666655],
  [2.777195652757438, 5.707305772636392],
  [3.1771971786363444, 6.307304246757486],
  [3.1771971786363444, 7.007305009696939],
  [3.777195652757438, 7.007305009696939],
  [4.377196034227165, 7.1073053911666655],
  [5.077196797166618, 7.207304818962076],
  [5.677197178636344, 7.307305200431802],
  [6.277195652757438, 7.407304628227212],
  [6.877197941575798, 7.507305009696939],
  [7.477196415696891, 7.6073053911666655],
  [8.177197178636344, 7.6073053911666655],
  [8.777195652757438, 7.6073053911666655],
  [9.477196415696891, 7.507305009696939],
  [10.177197178636344, 7.307305200431802],
  [10.777195652757438, 7.1073053911666655],
  [11.377197941575798, 6.707305772636392],
  [11.877197941575798, 6.307304246757486],
  [11.077194889817985, 6.007305009696939],
  [10.377197941575798, 5.707305772636392],
  [10.377197941575798, 6.507305009696939],
  [9.677197178636344, 6.807304246757486],
  [8.977196415696891, 6.707305772636392],
  [8.377197941575798, 6.207305772636392],
  [8.177197178636344, 6.907304628227212],
  [7.677197178636344, 6.407304628227212],
  [7.277195652757438, 6.907304628227212],
  [7.077194889817985, 6.207305772636392],
  [6.477196415696891, 6.707305772636392],
  [6.077196797166618, 6.007305009696939],
  [5.677197178636344, 6.6073053911666655],
  [5.277195652757438, 5.807304246757486],
  [5.477196415696891, 5.007305009696939],
  [5.977196415696891, 5.307304246757486],
  [6.577194889817985, 5.6073053911666655],
  [7.277195652757438, 5.407304628227212],
  [7.777195652757438, 5.707305772636392],
  [7.877197941575798, 5.1073053911666655],
  [7.877197941575798, 4.407304628227212],
  [7.877197941575798, 3.707305772636392],
  [7.777195652757438, 3.1073053911666655],
  [8.177197178636344, 2.707305772636392],
  [8.577194889817985, 2.207305772636392],
  [8.877197941575798, 1.6073053911666655],
  [8.377197941575798, 1.507305009696939],
  [7.677197178636344, 1.3073042467574858],
  [8.377197941575798, 0.9073046282272124],
  [8.877197941575798, 0.5073050096969389],
  [9.077194889817985, 1.1073053911666655],
  [9.477196415696891, 1.6073053911666655],
  [9.777195652757438, 2.1073053911666655],
  [9.177197178636344, 2.207305772636392],
  [9.477196415696891, 2.707305772636392],
  [8.777195652757438, 2.807304246757486],
  [8.477196415696891, 3.307304246757486],
  [8.877197941575798, 3.707305772636392],
  [8.377197941575798, 4.1073053911666655],
  [8.477196415696891, 4.707305772636392],
  [8.477196415696891, 5.407304628227212],
  [9.077194889817985, 5.807304246757486],
  [9.677197178636344, 6.1073053911666655],
  [9.677197178636344, 5.307304246757486],
  [9.077194889817985, 5.007305009696939],
  [8.977196415696891, 4.407304628227212],
  [9.577194889817985, 3.9073046282272124],
  [9.177197178636344, 3.307304246757486],
  [9.777195652757438, 3.207305772636392],
  [10.177197178636344, 3.707305772636392],
  [10.177197178636344, 4.307304246757486],
  [9.677197178636344, 4.6073053911666655],
  [10.277195652757438, 4.907304628227212],
  [10.977196415696891, 5.207305772636392],
  [11.677197178636344, 5.507305009696939],
  [12.277195652757438, 4.907304628227212],
  [12.377197941575798, 5.907304628227212],
  [12.877197941575798, 5.407304628227212],
  [13.277195652757438, 4.807304246757486],
  [13.677197178636344, 4.1073053911666655],
  [13.977196415696891, 3.507305009696939],
  [14.277195652757438, 2.807304246757486],
  [14.477196415696891, 2.007305009696939],
  [14.677197178636344, 1.3073042467574858],
  [14.677197178636344, 0.5073050096969389],
  [13.877197941575798, 0.10730539116666549],
  [13.177197178636344, -0.09269537177278764],
  [13.177197178636344, 0.6073053911666655],
  [13.877197941575798, 1.007305009696939],
  [13.677197178636344, 1.8073042467574858],
  [13.077194889817985, 1.3073042467574858],
  [12.477196415696891, 0.9073046282272124],
  [12.577194889817985, 0.20730577263639205],
  [11.977196415696891, -0.29269422736360795],
  [12.577194889817985, -0.4926949903030611],
  [11.977196415696891, -0.9926949903030611],
  [12.777195652757438, -1.1926957532425142],
  [13.177197178636344, -0.6926957532425142],
  [13.377197941575798, -1.3926946088333345],
  [14.077194889817985, -1.492694990303061],
  [13.977196415696891, -0.6926957532425142],
  [14.677197178636344, -0.29269422736360795],
  [14.777195652757438, -1.0926953717727876],
  [14.977196415696891, -1.8926946088333345],
  [14.177197178636344, -2.292694227363608],
  [14.577194889817985, -2.792694227363608],
  [15.277195652757438, -2.5926953717727876],
  [15.677197178636344, -3.292694227363608],
  [14.977196415696891, -3.492694990303061],
  [14.177197178636344, -3.292694227363608],
  [13.577194889817985, -3.5926953717727876],
  [13.077194889817985, -3.8926946088333345],
  [12.477196415696891, -3.3926946088333345],
  [12.477196415696891, -2.792694227363608],
  [13.077194889817985, -2.492694990303061],
  [13.077194889817985, -3.192695753242514],
  [13.677197178636344, -2.792694227363608],
  [13.577194889817985, -2.0926953717727876],
  [12.977196415696891, -1.792694227363608],
  [12.377197941575798, -2.192695753242514],
  [12.377197941575798, -1.5926953717727876],
  [11.777195652757438, -1.792694227363608],
  [11.377197941575798, -1.292694227363608],
  [11.477196415696891, -0.6926957532425142],
  [10.977196415696891, -0.3926946088333345],
  [11.377197941575798, 0.0073050096969389244],
  [11.977196415696891, 0.40730462822721236],
  [11.877197941575798, 1.1073053911666655],
  [12.377197941575798, 1.6073053911666655],
  [12.877197941575798, 2.1073053911666655],
  [13.377197941575798, 2.707305772636392],
  [13.077194889817985, 3.507305009696939],
  [12.777195652757438, 4.207305772636392],
  [11.977196415696891, 4.207305772636392],
  [11.477196415696891, 4.6073053911666655],
  [10.877197941575798, 4.407304628227212],
  [10.777195652757438, 3.707305772636392],
  [11.477196415696891, 3.807304246757486],
  [12.277195652757438, 3.507305009696939],
  [12.577194889817985, 2.807304246757486],
  [12.177197178636344, 2.307304246757486],
  [11.777195652757438, 1.8073042467574858],
  [11.177197178636344, 2.007305009696939],
  [11.477196415696891, 2.507305009696939],
  [11.877197941575798, 3.007305009696939],
  [11.177197178636344, 3.207305772636392],
  [10.877197941575798, 2.6073053911666655],
  [10.577194889817985, 3.207305772636392],
  [10.177197178636344, 2.6073053911666655],
  [10.477196415696891, 2.1073053911666655],
  [10.777195652757438, 1.507305009696939],
  [10.177197178636344, 1.507305009696939],
  [9.777195652757438, 1.007305009696939],
  [9.477196415696891, 0.5073050096969389],
  [10.177197178636344, 0.5073050096969389],
  [10.577194889817985, 1.007305009696939],
  [11.277195652757438, 1.3073042467574858],
  [11.277195652757438, 0.707305772636392],
  [10.877197941575798, 0.40730462822721236],
  [10.477196415696891, 0.0073050096969389244],
  [9.877197941575798, -0.09269537177278764],
  [9.277195652757438, -0.09269537177278764],
  [8.677197178636344, -0.09269537177278764],
  [8.977196415696891, -0.5926953717727876],
  [9.277195652757438, -1.1926957532425142],
  [9.077194889817985, -1.792694227363608],
  [8.577194889817985, -1.1926957532425142],
  [8.377197941575798, -1.792694227363608],
  [7.977196415696891, -2.3926946088333345],
  [8.877197941575798, -2.3926946088333345],
  [8.377197941575798, -2.8926946088333345],
  [7.877197941575798, -3.292694227363608],
  [7.277195652757438, -3.492694990303061],
  [7.077194889817985, -2.8926946088333345],
  [6.877197941575798, -2.0926953717727876],
  [6.377196034227165, -2.492694990303061],
  [6.277195652757438, -1.6926957532425142],
  [5.677197178636344, -2.292694227363608],
  [5.477196415696891, -1.5926953717727876],
  [5.977196415696891, -1.0926953717727876],
  [6.977196415696891, -0.5926953717727876],
  [7.277195652757438, -1.1926957532425142],
  [7.577194889817985, -1.792694227363608],
  [7.977196415696891, -1.1926957532425142],
  [8.277195652757438, -0.5926953717727876],
  [7.577194889817985, -0.3926946088333345],
  [8.177197178636344, 0.20730577263639205],
  [7.577194889817985, 0.6073053911666655],
  [6.977196415696891, 0.20730577263639205],
  [6.077196797166618, 0.3073042467574858],
  [5.877196034227165, -0.3926946088333345],
  [5.277195652757438, -0.792694227363608],
  [4.577196797166618, -0.8926946088333345],
  [4.077196797166618, -0.4926949903030611],
  [4.677197178636344, -0.29269422736360795],
  [5.377196034227165, -0.09269537177278764],
  [5.477196415696891, 0.6073053911666655],
  [4.877196034227165, 0.40730462822721236],
  [4.177197178636344, 0.20730577263639205],
  [3.777195652757438, 0.707305772636392],
  [3.1771971786363444, 0.40730462822721236],
  [3.577196797166618, -0.09269537177278764],
  [2.9771964156968913, -0.29269422736360795],
  [3.3771960342271647, -0.8926946088333345],
  [2.577196797166618, -1.292694227363608],
  [2.077196797166618, -0.4926949903030611],
  [2.3771960342271647, 0.3073042467574858],
  [1.6771971786363444, 0.3073042467574858],
  [0.8771960342271647, 0.707305772636392],
  [0.37719603422716474, 0.10730539116666549],
  [-0.12280396577283526, -0.3926946088333345],
  [1.0771967971666179, -0.3926946088333345],
  [1.1771971786363444, -1.1926957532425142],
  [0.5771967971666179, -1.8926946088333345],
  [-0.022803584303108693, -1.6926957532425142],
  [0.37719603422716474, -0.9926949903030611],
  [-0.42280320283338213, -0.9926949903030611],
  [-0.7228043472425618, -1.492694990303061],
  [-1.2228043472425618, -1.292694227363608],
  [-1.7228043472425618, -1.5926953717727876],
  [-2.3228028213636556, -1.8926946088333345],
  [-2.8228028213636556, -2.292694227363608],
  [-2.222804347242562, -2.5926953717727876],
  [-1.7228043472425618, -2.292694227363608],
  [-1.1228039657728353, -1.992694990303061],
  [-0.5228035843031087, -2.192695753242514],
  [0.07719679716661787, -2.492694990303061],
  [0.6771971786363444, -2.8926946088333345],
  [1.4771964156968913, -2.5926953717727876],
  [1.3771960342271647, -1.8926946088333345],
  [2.6771971786363444, -2.0926953717727876],
  [2.777195652757438, -2.8926946088333345],
  [3.577196797166618, -2.792694227363608],
  [4.177197178636344, -2.0926953717727876],
  [3.3771960342271647, -1.792694227363608],
  [3.9771964156968913, -1.3926946088333345],
  [4.777195652757438, -1.5926953717727876],
  [4.877196034227165, -2.292694227363608],
  [5.277195652757438, -2.992694990303061],
  [6.077196797166618, -3.0926953717727876],
  [6.677197178636344, -3.692695753242514],
  [5.977196415696891, -3.792694227363608],
  [6.377196034227165, -4.992694990303061],
  [7.477196415696891, -4.692695753242514],
  [7.377197941575798, -5.792694227363608],
  [6.577194889817985, -5.992694990303061],
  [6.677197178636344, -6.8926946088333345],
  [7.377197941575798, -6.692695753242514],
  [8.077194889817985, -7.192695753242514],
  [8.277195652757438, -6.292694227363608],
  [8.477196415696891, -5.3926946088333345],
  [9.277195652757438, -4.692695753242514],
  [8.477196415696891, -4.092695371772788],
  [8.877197941575798, -3.292694227363608],
  [9.377197941575798, -3.692695753242514],
  [9.477196415696891, -2.8926946088333345],
  [9.577194889817985, -2.192695753242514],
  [10.177197178636344, -1.992694990303061],
  [9.677197178636344, -1.5926953717727876],
  [10.177197178636344, -1.1926957532425142],
  [9.677197178636344, -0.6926957532425142],
  [10.277195652757438, -0.5926953717727876],
  [10.877197941575798, -0.9926949903030611],
  [10.777195652757438, -1.6926957532425142],
  [11.277195652757438, -1.992694990303061],
  [10.677197178636344, -2.3926946088333345],
  [10.077194889817985, -2.692695753242514],
  [10.677197178636344, -3.0926953717727876],
  [10.077194889817985, -3.3926946088333345],
  [10.077194889817985, -4.092695371772788],
  [10.577194889817985, -4.492694990303061],
  [10.177197178636344, -5.292694227363608],
  [11.277195652757438, -4.8926946088333345],
  [11.377197941575798, -4.192695753242514],
  [10.677197178636344, -3.792694227363608],
  [11.277195652757438, -3.3926946088333345],
  [11.277195652757438, -2.692695753242514],
  [11.777195652757438, -2.3926946088333345],
  [11.877197941575798, -2.992694990303061],
  [11.877197941575798, -3.692695753242514],
  [12.377197941575798, -4.092695371772788],
  [12.077194889817985, -4.692695753242514],
  [11.977196415696891, -5.3926946088333345],
  [12.877197941575798, -5.192695753242514],
  [12.877197941575798, -4.492694990303061],
  [13.577194889817985, -4.292694227363608],
  [14.177197178636344, -3.992694990303061],
  [14.777195652757438, -4.192695753242514],
  [15.477196415696891, -4.192695753242514],
  [16.177197178636344, -3.8926946088333345],
  [16.677197178636344, -4.3926946088333345],
  [16.97719641569689, -5.092695371772788],
  [16.877197941575798, -5.792694227363608],
  [16.47719641569689, -5.3926946088333345],
  [16.277195652757438, -4.692695753242514],
  [15.777195652757438, -5.092695371772788],
  [15.777195652757438, -5.8926946088333345],
  [15.277195652757438, -6.592695371772788],
  [16.077194889817985, -6.592695371772788],
  [16.47719641569689, -6.092695371772788],
  [16.677197178636344, -6.592695371772788],
  [16.377197941575798, -7.192695753242514],
  [16.077194889817985, -7.8926946088333345],
  [15.677197178636344, -8.392694608833335],
  [15.277195652757438, -7.792694227363608],
  [15.677197178636344, -7.192695753242514],
  [14.977196415696891, -7.192695753242514],
  [14.577194889817985, -6.592695371772788],
  [14.977196415696891, -6.092695371772788],
  [15.177197178636344, -5.492694990303061],
  [14.577194889817985, -5.3926946088333345],
  [14.977196415696891, -4.792694227363608],
  [14.177197178636344, -4.692695753242514],
  [13.477196415696891, -4.992694990303061],
  [13.977196415696891, -5.3926946088333345],
  [14.277195652757438, -5.992694990303061],
  [13.477196415696891, -5.792694227363608],
  [12.477196415696891, -5.992694990303061],
  [12.877197941575798, -6.592695371772788],
  [13.777195652757438, -6.592695371772788],
  [14.177197178636344, -7.292694227363608],
  [14.577194889817985, -7.8926946088333345],
  [13.777195652757438, -7.992694990303061],
  [13.177197178636344, -7.292694227363608],
  [12.977196415696891, -7.992694990303061],
  [13.477196415696891, -8.792694227363608],
  [14.277195652757438, -8.692695753242514],
  [14.877197941575798, -8.392694608833335],
  [15.277195652757438, -8.892694608833335],
  [14.677197178636344, -9.392696516181967],
  [14.077194889817985, -9.592693464424155],
  [13.377197941575798, -9.592693464424155],
  [12.777195652757438, -9.292694227363608],
  [12.577194889817985, -8.592695371772788],
  [9.977196415696891, -8.392694608833335],
  [10.077194889817985, -7.692695753242514],
  [10.077194889817985, -6.8926946088333345],
  [10.077194889817985, -6.192695753242514],
  [9.177197178636344, -6.092695371772788],
  [8.977196415696891, -6.992694990303061],
  [9.277195652757438, -7.792694227363608],
  [8.977196415696891, -8.592695371772788],
  [9.577194889817985, -8.992694990303061],
  [8.977196415696891, -9.392696516181967],
  [8.177197178636344, -9.492694990303061],
  [8.277195652757438, -8.792694227363608],
  [8.477196415696891, -7.992694990303061],
  [7.777195652757438, -8.492694990303061],
  [7.377197941575798, -8.992694990303061],
  [7.477196415696891, -9.492694990303061],
  [6.677197178636344, -9.492694990303061],
  [6.177197178636344, -9.492694990303061],
  [6.677197178636344, -8.892694608833335],
  [7.077194889817985, -8.292694227363608],
  [7.777195652757438, -7.8926946088333345],
  [7.277195652757438, -7.492694990303061],
  [6.577194889817985, -7.692695753242514],
  [6.377196034227165, -8.292694227363608],
  [5.877196034227165, -7.992694990303061],
  [5.377196034227165, -8.292694227363608],
  [5.177197178636344, -8.892694608833335],
  [5.877196034227165, -8.792694227363608],
  [5.477196415696891, -9.492694990303061],
  [4.977196415696891, -9.492694990303061],
  [4.577196797166618, -9.092693464424155],
  [4.577196797166618, -8.492694990303061],
  [4.877196034227165, -7.8926946088333345],
  [5.377196034227165, -7.592695371772788],
  [5.977196415696891, -7.192695753242514],
  [5.977196415696891, -6.592695371772788],
  [5.677197178636344, -5.8926946088333345],
  [5.377196034227165, -5.292694227363608],
  [4.977196415696891, -4.692695753242514],
  [5.377196034227165, -3.8926946088333345],
  [4.677197178636344, -3.992694990303061],
  [4.477196415696891, -2.992694990303061],
  [4.077196797166618, -3.8926946088333345],
  [3.4771964156968913, -3.8926946088333345],
  [2.777195652757438, -3.792694227363608],
  [2.1771971786363444, -3.692695753242514],
  [1.4771964156968913, -3.292694227363608],
  [1.4771964156968913, -3.8926946088333345],
  [0.6771971786363444, -3.792694227363608],
  [0.07719679716661787, -3.292694227363608],
  [-0.5228035843031087, -2.8926946088333345],
  [-1.0228035843031087, -2.5926953717727876],
  [-1.6228039657728353, -2.8926946088333345],
  [-2.1228039657728353, -3.192695753242514],
  [-2.722804347242562, -2.992694990303061],
  [-3.3228028213636556, -2.792694227363608],
  [-3.422803202833382, -1.992694990303061],
  [-2.922803202833382, -1.492694990303061],
  [-2.3228028213636556, -1.1926957532425142],
  [-1.7228043472425618, -0.8926946088333345],
  [-2.0228035843031087, -0.3926946088333345],
  [-2.6228039657728353, -0.6926957532425142],
  [-3.1228039657728353, -0.8926946088333345],
  [-2.5228035843031087, 0.0073050096969389244],
  [-2.422803202833382, 0.707305772636392],
  [-1.8228028213636556, 0.9073046282272124],
  [-1.7228043472425618, 1.6073053911666655],
  [-1.3228028213636556, 2.1073053911666655],
  [-1.6228039657728353, 2.807304246757486],
  [-1.9228032028333821, 2.307304246757486],
  [-2.422803202833382, 1.9073046282272124],
  [-2.3228028213636556, 1.3073042467574858],
  [-2.922803202833382, 1.6073053911666655],
  [-3.0228035843031087, 1.007305009696939],
  [-3.1228039657728353, 0.40730462822721236],
  [-3.1228039657728353, -0.29269422736360795],
  [-3.722804347242562, 0.10730539116666549],
  [-4.322802821363656, 0.5073050096969389],
  [-4.522803584303109, -0.29269422736360795],
  [-3.8228028213636556, -0.5926953717727876],
  [-3.6228039657728353, -1.292694227363608],
  [-4.222804347242562, -1.792694227363608],
  [-4.422803202833382, -0.9926949903030611],
  [-5.022803584303109, -1.6926957532425142],
  [-5.922803202833382, -1.6926957532425142],
  [-6.222804347242562, -1.0926953717727876],
  [-5.722804347242562, -0.29269422736360795],
  [-5.122803965772835, -0.792694227363608],
  [-5.122803965772835, 0.10730539116666549],
  [-5.022803584303109, 0.9073046282272124],
  [-4.922803202833382, 1.6073053911666655],
  [-4.322802821363656, 2.007305009696939],
  [-4.322802821363656, 1.207305772636392],
  [-3.722804347242562, 0.8073042467574858],
  [-3.6228039657728353, 1.6073053911666655],
  [-3.8228028213636556, 2.4073046282272124],
  [-3.1228039657728353, 2.207305772636392],
  [-2.6228039657728353, 2.507305009696939],
  [-2.1228039657728353, 3.007305009696939],
  [-2.722804347242562, 3.207305772636392],
  [-3.222804347242562, 2.807304246757486],
  [-3.422803202833382, 3.4073046282272124],
  [-3.922803202833382, 3.1073053911666655],
  [-4.422803202833382, 3.4073046282272124],
  [-4.422803202833382, 2.707305772636392],
  [-4.922803202833382, 2.307304246757486],
  [-5.122803965772835, 3.007305009696939],
  [-5.622803965772835, 2.707305772636392],
  [-6.322802821363656, 2.4073046282272124],
  [-5.622803965772835, 2.007305009696939],
  [-5.722804347242562, 1.3073042467574858],
  [-6.322802821363656, 1.707305772636392],
  [-7.022803584303109, 1.9073046282272124],
  [-6.722804347242562, 1.1073053911666655],
  [-5.922803202833382, 0.5073050096969389],
  [-6.522803584303109, -0.4926949903030611],
  [-6.822802821363656, 0.10730539116666549],
  [-7.522803584303109, 0.0073050096969389244],
  [-7.522803584303109, 0.707305772636392],
  [-7.622803965772835, 1.4073046282272124],
  [-7.822802821363656, 2.007305009696939],
  [-8.322802821363656, 2.4073046282272124],
  [-8.622803965772835, 2.9073046282272124],
  [-8.522803584303109, 3.507305009696939],
  [-8.022803584303109, 3.207305772636392],
  [-7.622803965772835, 2.6073053911666655],
  [-7.022803584303109, 2.6073053911666655],
  [-7.322802821363656, 3.1073053911666655],
  [-7.522803584303109, 3.707305772636392],
  [-8.122803965772835, 3.807304246757486],
  [-7.622803965772835, 4.307304246757486],
  [-7.022803584303109, 4.207305772636392],
  [-6.822802821363656, 3.707305772636392],
  [-6.622803965772835, 3.1073053911666655],
  [-5.922803202833382, 3.1073053911666655],
  [-6.222804347242562, 3.707305772636392],
  [-5.622803965772835, 3.6073053911666655],
  [-5.822802821363656, 4.207305772636392],
  [-6.422803202833382, 4.207305772636392],
  [-6.622803965772835, 4.807304246757486],
  [-6.022803584303109, 4.807304246757486],
  [-5.422803202833382, 4.807304246757486],
  [-5.222804347242562, 4.207305772636392],
  [-5.022803584303109, 3.6073053911666655],
  [-4.522803584303109, 4.1073053911666655],
  [-4.022803584303109, 3.807304246757486],
  [-3.6228039657728353, 4.507305009696939],
  [-4.222804347242562, 4.507305009696939],
  [-4.822802821363656, 4.707305772636392],
  [-4.422803202833382, 5.207305772636392],
  [-5.022803584303109, 5.307304246757486],
  [-5.322802821363656, 5.907304628227212],
  [-4.722804347242562, 5.907304628227212],
  [-5.022803584303109, 6.507305009696939],
  [-4.722804347242562, 7.007305009696939],
  [-4.122803965772835, 7.307305200431802],
  [-3.8228028213636556, 6.807304246757486],
  [-4.322802821363656, 6.507305009696939],
  [-4.122803965772835, 5.807304246757486],
  [-3.922803202833382, 5.1073053911666655],
  [-3.5228035843031087, 5.6073053911666655],
  [-2.922803202833382, 5.407304628227212],
  [-3.222804347242562, 5.007305009696939],
  [-3.0228035843031087, 4.407304628227212],
  [-3.422803202833382, 4.007305009696939],
  [-2.8228028213636556, 3.807304246757486],
  [-2.3228028213636556, 3.6073053911666655],
  [-1.7228043472425618, 3.4073046282272124],
  [-1.2228043472425618, 3.307304246757486],
  [-0.6228039657728353, 3.307304246757486],
  [-0.42280320283338213, 3.9073046282272124],
  [-0.7228043472425618, 4.407304628227212],
  [-1.3228028213636556, 4.507305009696939],
  [-1.1228039657728353, 3.9073046282272124],
  [-1.8228028213636556, 4.007305009696939],
  [-2.422803202833382, 4.307304246757486],
  [-1.9228032028333821, 4.707305772636392],
  [-2.5228035843031087, 4.907304628227212],
  [-2.0228035843031087, 5.407304628227212],
  [-1.5228035843031087, 5.1073053911666655],
  [-0.9228032028333821, 5.007305009696939],
  [-0.6228039657728353, 5.6073053911666655],
  [-0.22280434724256182, 6.1073053911666655],
  [0.07719679716661787, 6.707305772636392],
  [-0.22280434724256182, 7.407304628227212],
  [-0.9228032028333821, 7.6073053911666655],
  [-0.7228043472425618, 6.807304246757486],
  [-0.9228032028333821, 6.207305772636392],
  [-1.3228028213636556, 5.707305772636392],
  [-1.9228032028333821, 6.007305009696939],
  [-2.422803202833382, 5.707305772636392],
  [-2.5228035843031087, 6.307304246757486],
  [-3.0228035843031087, 6.007305009696939],
  [-3.722804347242562, 6.207305772636392],
  [-3.222804347242562, 6.707305772636392],
  [-2.6228039657728353, 6.907304628227212],
  [-2.0228035843031087, 6.707305772636392],
  [-1.4228032028333821, 6.507305009696939],
  [-1.4228032028333821, 7.1073053911666655],
  [-1.6228039657728353, 7.807305200431802],
  [-2.1228039657728353, 7.307305200431802],
  [-2.422803202833382, 7.907304628227212],
  [-2.8228028213636556, 7.507305009696939],
  [-3.1228039657728353, 7.907304628227212],
  [-3.422803202833382, 7.307305200431802],
  [-3.8228028213636556, 7.807305200431802],
  [-4.622803965772835, 7.707304818962076],
  [-5.322802821363656, 7.6073053911666655],
  [-5.422803202833382, 7.007305009696939],
  [-5.622803965772835, 6.407304628227212],
  [-6.022803584303109, 5.907304628227212],
  [-6.322802821363656, 6.407304628227212],
  [-6.122803965772835, 6.907304628227212],
  [-6.022803584303109, 7.507305009696939],
  [-6.822802821363656, 7.407304628227212],
  [-6.822802821363656, 6.907304628227212],
  [-7.522803584303109, 6.807304246757486],
  [-7.122803965772835, 6.307304246757486],
  [-6.622803965772835, 5.907304628227212],
  [-5.722804347242562, 5.307304246757486],
  [-6.322802821363656, 5.307304246757486],
  [-6.922803202833382, 5.307304246757486],
  [-7.322802821363656, 4.807304246757486],
  [-7.822802821363656, 4.907304628227212],
  [-7.522803584303109, 5.307304246757486],
  [-7.222804347242562, 5.807304246757486],
  [-7.722804347242562, 6.1073053911666655],
  [-8.322802821363656, 6.207305772636392],
  [-8.122803965772835, 6.707305772636392],
  [-7.422803202833382, 7.307305200431802],
  [-8.022803584303109, 7.307305200431802],
  [-8.622803965772835, 7.307305200431802],
  [-9.222804347242562, 7.307305200431802],
  [-9.722803393568245, 7.207304818962076],
  [-10.322803775037972, 7.207304818962076],
  [-10.922803202833382, 7.207304818962076],
  [-11.922803202833382, 6.707305772636392],
  [-11.322803775037972, 6.707305772636392],
  [-10.622803965772835, 6.6073053911666655],
  [-10.022803584303109, 6.707305772636392],
  [-10.222803393568245, 6.1073053911666655],
  [-9.622803965772835, 6.1073053911666655],
  [-9.422803202833382, 6.707305772636392],
  [-8.722804347242562, 6.707305772636392],
  [-9.022803584303109, 6.207305772636392],
  [-9.222804347242562, 5.6073053911666655],
  [-9.822803775037972, 5.507305009696939],
  [-10.322803775037972, 5.407304628227212],
  [-10.022803584303109, 4.907304628227212],
  [-9.422803202833382, 5.007305009696939],
  [-8.922803202833382, 5.1073053911666655],
  [-8.622803965772835, 5.6073053911666655],
  [-8.022803584303109, 5.6073053911666655],
  [-8.422803202833382, 5.007305009696939],
  [-8.322802821363656, 4.407304628227212],
  [-8.922803202833382, 4.507305009696939],
  [-8.722804347242562, 4.007305009696939],
  [-9.322802821363656, 3.9073046282272124],
  [-9.622803965772835, 4.407304628227212],
  [-10.222803393568245, 4.307304246757486],
  [-9.922803202833382, 3.9073046282272124],
  [-10.622803965772835, 3.807304246757486],
  [-10.822803775037972, 4.407304628227212],
  [-10.522803584303109, 4.907304628227212],
  [-11.222803393568245, 4.907304628227212],
  [-11.022803584303109, 5.407304628227212],
  [-10.922803202833382, 6.007305009696939],
  [-11.322803775037972, 6.207305772636392],
  [-11.922803202833382, 6.1073053911666655],
  [-12.522803584303109, 6.507305009696939],
  [-12.322803775037972, 7.307305200431802],
  [-11.722803393568245, 7.207304818962076],
  [-11.322803775037972, 7.6073053911666655],
  [-11.622803965772835, 8.007305009696939],
  [-12.222803393568245, 7.807305200431802],
  [-12.822803775037972, 7.407304628227212],
  [-13.022803584303109, 6.807304246757486],
  [-13.622803965772835, 6.807304246757486],
  [-13.322803775037972, 7.307305200431802],
  [-13.922803202833382, 7.307305200431802],
  [-14.422803202833382, 7.1073053911666655],
  [-14.822803775037972, 6.707305772636392],
  [-15.222803393568245, 6.307304246757486],
  [-14.622803965772835, 6.307304246757486],
  [-14.122803965772835, 6.6073053911666655],
  [-14.022803584303109, 6.007305009696939],
  [-13.522803584303109, 6.307304246757486],
  [-13.022803584303109, 6.1073053911666655],
  [-12.522803584303109, 5.907304628227212],
  [-12.222803393568245, 5.407304628227212],
  [-12.922803202833382, 5.407304628227212],
  [-13.422803202833382, 5.707305772636392],
  [-14.022803584303109, 5.307304246757486],
  [-13.522803584303109, 5.1073053911666655],
  [-13.022803584303109, 4.807304246757486],
  [-12.522803584303109, 4.907304628227212],
  [-12.022803584303109, 4.907304628227212],
  [-11.522803584303109, 4.407304628227212],
  [-12.222803393568245, 4.307304246757486],
  [-12.822803775037972, 4.207305772636392],
  [-13.322803775037972, 4.007305009696939],
  [-13.422803202833382, 4.507305009696939],
  [-14.022803584303109, 4.707305772636392],
  [-14.622803965772835, 5.007305009696939],
  [-14.422803202833382, 5.6073053911666655],
  [-14.922803202833382, 5.6073053911666655],
  [-15.522803584303109, 5.707305772636392],
  [-15.922803202833382, 5.307304246757486],
  [-16.422803202833382, 4.907304628227212],
  [-16.822803775037972, 4.6073053911666655],
  [-17.322803775037972, 4.307304246757486],
  [-17.822803775037972, 4.1073053911666655],
  [-18.02280358430311, 3.6073053911666655],
  [-17.422803202833382, 3.707305772636392],
  [-17.422803202833382, 3.1073053911666655],
  [-16.922803202833382, 4.007305009696939],
  [-16.922803202833382, 3.507305009696939],
  [-16.322803775037972, 3.807304246757486],
  [-15.922803202833382, 4.207305772636392],
  [-15.422803202833382, 4.1073053911666655],
  [-15.822803775037972, 3.507305009696939],
  [-15.822803775037972, 2.807304246757486],
  [-15.822803775037972, 2.307304246757486],
  [-16.422803202833382, 4.307304246757486],
  [-15.822803775037972, 4.707305772636392],
  [-15.222803393568245, 5.1073053911666655],
  [-15.022803584303109, 4.507305009696939],
  [-14.422803202833382, 4.307304246757486],
  [-13.922803202833382, 4.1073053911666655],
  [-14.322803775037972, 3.707305772636392],
  [-14.822803775037972, 3.9073046282272124],
  [-15.222803393568245, 3.507305009696939],
  [-16.222803393568245, 3.207305772636392],
  [-16.322803775037972, 2.6073053911666655],
  [-17.02280358430311, 2.9073046282272124],
  [-17.822803775037972, 3.1073053911666655],
  [-17.52280358430311, 2.707305772636392],
  [-17.222803393568245, 2.4073046282272124],
  [-16.922803202833382, 2.007305009696939],
  [-16.422803202833382, 1.6073053911666655],
  [-15.922803202833382, 1.4073046282272124],
  [-15.422803202833382, 1.207305772636392],
  [-14.822803775037972, 1.1073053911666655],
  [-14.122803965772835, 1.1073053911666655],
  [-13.522803584303109, 1.207305772636392],
  [-12.822803775037972, 1.1073053911666655],
  [-12.622803965772835, 2.207305772636392],
  [-11.922803202833382, 1.707305772636392],
  [-12.122803965772835, 0.9073046282272124],
  [-11.422803202833382, 0.707305772636392],
  [-11.022803584303109, 1.3073042467574858],
  [-10.322803775037972, 1.8073042467574858],
  [-10.522803584303109, 2.507305009696939],
  [-11.122803965772835, 2.1073053911666655],
  [-11.222803393568245, 2.807304246757486],
  [-11.922803202833382, 2.507305009696939],
  [-11.922803202833382, 3.207305772636392],
  [-12.522803584303109, 3.007305009696939],
  [-13.322803775037972, 2.807304246757486],
  [-13.422803202833382, 2.007305009696939],
  [-14.322803775037972, 1.8073042467574858],
  [-15.222803393568245, 2.007305009696939],
  [-15.322803775037972, 2.807304246757486],
  [-14.722803393568245, 3.207305772636392],
  [-14.622803965772835, 2.6073053911666655],
  [-13.922803202833382, 2.507305009696939],
  [-14.122803965772835, 3.1073053911666655],
  [-13.622803965772835, 3.507305009696939],
  [-13.022803584303109, 3.507305009696939],
  [-12.422803202833382, 3.707305772636392],
  [-11.822803775037972, 3.807304246757486],
  [-11.222803393568245, 4.007305009696939],
  [-11.322803775037972, 3.4073046282272124],
  [-10.722803393568245, 3.1073053911666655],
  [-10.222803393568245, 3.307304246757486],
  [-9.622803965772835, 3.307304246757486],
  [-9.022803584303109, 3.4073046282272124],
  [-9.222804347242562, 2.807304246757486],
  [-9.922803202833382, 2.807304246757486],
  [-9.722803393568245, 2.207305772636392],
  [-9.022803584303109, 2.207305772636392],
  [-8.522803584303109, 1.6073053911666655],
  [-8.422803202833382, 0.8073042467574858],
  [-8.122803965772835, 0.0073050096969389244],
  [-8.822802821363656, 0.0073050096969389244],
  [-9.222804347242562, 0.707305772636392],
  [-9.422803202833382, 1.507305009696939],
  [-10.122803965772835, 1.007305009696939],
  [-10.722803393568245, 0.40730462822721236],
  [-10.022803584303109, 0.20730577263639205],
  [-9.422803202833382, -0.09269537177278764],
  [-9.422803202833382, -0.8926946088333345],
  [-9.722803393568245, -1.5926953717727876],
  [-9.922803202833382, -2.292694227363608],
  [-10.222803393568245, -2.8926946088333345],
  [-10.522803584303109, -3.5926953717727876],
  [-10.822803775037972, -4.192695753242514],
  [-11.022803584303109, -4.792694227363608],
  [-10.422803202833382, -5.3926946088333345],
  [-11.422803202833382, -5.292694227363608],
  [-11.722803393568245, -5.8926946088333345],
  [-12.122803965772835, -6.3926946088333345],
  [-12.522803584303109, -6.8926946088333345],
  [-13.022803584303109, -7.292694227363608],
  [-13.622803965772835, -7.592695371772788],
  [-14.022803584303109, -7.8926946088333345],
  [-14.322803775037972, -8.392694608833335],
  [-14.622803965772835, -8.892694608833335],
  [-14.622803965772835, -9.392696516181967],
  [-14.122803965772835, -9.692695753242514],
  [-14.022803584303109, -8.992694990303061],
  [-13.422803202833382, -9.092693464424155],
  [-13.522803584303109, -9.792694227363608],
  [-12.922803202833382, -9.892696516181967],
  [-12.822803775037972, -9.292694227363608],
  [-13.622803965772835, -8.392694608833335],
  [-13.022803584303109, -7.992694990303061],
  [-12.922803202833382, -8.692695753242514],
  [-12.422803202833382, -8.192695753242514],
  [-11.822803775037972, -8.492694990303061],
  [-11.722803393568245, -7.792694227363608],
  [-12.422803202833382, -7.592695371772788],
  [-11.922803202833382, -7.092695371772788],
  [-11.222803393568245, -7.192695753242514],
  [-11.122803965772835, -7.792694227363608],
  [-10.722803393568245, -6.792694227363608],
  [-11.422803202833382, -6.492694990303061],
  [-11.022803584303109, -5.8926946088333345],
  [-10.322803775037972, -6.192695753242514],
  [-9.722803393568245, -5.792694227363608],
  [-9.822803775037972, -6.792694227363608],
  [-8.922803202833382, -6.992694990303061],
  [-9.622803965772835, -7.692695753242514],
  [-10.422803202833382, -7.3926946088333345],
  [-10.422803202833382, -8.192695753242514],
  [-9.922803202833382, -8.692695753242514],
  [-10.722803393568245, -9.092693464424155],
  [-11.222803393568245, -8.492694990303061],
  [-11.522803584303109, -9.192695753242514],
  [-12.222803393568245, -8.992694990303061],
  [-12.322803775037972, -9.892696516181967],
  [-11.722803393568245, -9.892696516181967],
  [-11.022803584303109, -9.892696516181967],
  [-10.322803775037972, -9.892696516181967],
  [-9.722803393568245, -9.592693464424155],
  [-9.322802821363656, -9.092693464424155],
  [-8.922803202833382, -8.592695371772788],
  [-8.622803965772835, -7.992694990303061],
  [-8.222804347242562, -7.592695371772788],
  [-7.722804347242562, -7.192695753242514],
  [-7.122803965772835, -6.8926946088333345],
  [-6.622803965772835, -6.692695753242514],
  [-6.022803584303109, -6.292694227363608],
  [-5.422803202833382, -5.992694990303061],
  [-4.922803202833382, -5.592695371772788],
  [-6.022803584303109, -4.792694227363608],
  [-7.022803584303109, -5.492694990303061],
  [-7.922803202833382, -6.192695753242514],
  [-8.922803202833382, -5.992694990303061],
  [-8.322802821363656, -5.192695753242514],
  [-9.322802821363656, -4.992694990303061],
  [-10.122803965772835, -4.592695371772788],
  [-9.622803965772835, -3.8926946088333345],
  [-9.122803965772835, -2.992694990303061],
  [-8.722804347242562, -2.0926953717727876],
  [-8.022803584303109, -1.1926957532425142],
  [-7.322802821363656, -2.192695753242514],
  [-8.022803584303109, -3.192695753242514],
  [-8.622803965772835, -4.092695371772788],
  [-7.522803584303109, -4.3926946088333345],
  [-6.722804347242562, -3.492694990303061],
  [-5.622803965772835, -2.292694227363608],
  [-5.422803202833382, -2.8926946088333345],
  [-5.022803584303109, -3.492694990303061],
  [-4.722804347242562, -2.492694990303061],
  [-3.922803202833382, -2.492694990303061],
  [-4.122803965772835, -3.292694227363608],
  [-3.1228039657728353, -3.5926953717727876],
  [-3.8228028213636556, -4.092695371772788],
  [-4.822802821363656, -3.992694990303061],
  [-4.522803584303109, -4.592695371772788],
  [-4.422803202833382, -5.192695753242514],
  [-3.922803202833382, -5.592695371772788],
  [-3.722804347242562, -6.092695371772788],
  [-3.422803202833382, -4.792694227363608],
  [-2.722804347242562, -4.292694227363608],
  [-2.422803202833382, -3.692695753242514],
  [-2.0228035843031087, -4.192695753242514],
  [-1.7228043472425618, -3.5926953717727876],
  [-1.1228039657728353, -3.292694227363608],
  [-0.6228039657728353, -3.692695753242514],
  [-0.022803584303108693, -4.092695371772788],
  [0.5771967971666179, -4.592695371772788],
  [1.3771960342271647, -4.592695371772788],
  [1.2771956527574382, -5.292694227363608],
  [1.1771971786363444, -5.8926946088333345],
  [0.9771964156968913, -6.592695371772788],
  [0.8771960342271647, -7.292694227363608],
  [0.9771964156968913, -7.992694990303061],
  [0.9771964156968913, -8.592695371772788],
  [0.7771956527574382, -9.292694227363608],
  [0.2771956527574382, -9.692695753242514],
  [-0.42280320283338213, -9.692695753242514],
  [-0.42280320283338213, -9.092693464424155],
  [0.17719717863634443, -8.792694227363608],
  [-0.42280320283338213, -8.292694227363608],
  [0.17719717863634443, -7.8926946088333345],
  [0.07719679716661787, -6.992694990303061],
  [0.2771956527574382, -6.192695753242514],
  [-0.5228035843031087, -6.292694227363608],
  [-0.8228028213636556, -6.8926946088333345],
  [-0.5228035843031087, -7.592695371772788],
  [-1.1228039657728353, -7.992694990303061],
  [-1.3228028213636556, -7.3926946088333345],
  [-1.5228035843031087, -6.8926946088333345],
  [-1.2228043472425618, -6.292694227363608],
  [-1.0228035843031087, -5.692695753242514],
  [-0.32280282136365557, -5.592695371772788],
  [0.37719603422716474, -5.3926946088333345],
  [-0.22280434724256182, -4.792694227363608],
  [-0.9228032028333821, -4.992694990303061],
  [-0.7228043472425618, -4.3926946088333345],
  [-1.2228043472425618, -3.992694990303061],
  [-1.4228032028333821, -4.592695371772788],
  [-1.5228035843031087, -5.192695753242514],
  [-2.0228035843031087, -4.792694227363608],
  [-2.6228039657728353, -4.992694990303061],
  [-3.0228035843031087, -5.592695371772788],
  [-2.222804347242562, -5.592695371772788],
  [-1.6228039657728353, -5.792694227363608],
  [-1.9228032028333821, -6.292694227363608],
  [-2.222804347242562, -6.792694227363608],
  [-2.722804347242562, -7.192695753242514],
  [-2.6228039657728353, -6.292694227363608],
  [-3.422803202833382, -6.592695371772788],
  [-3.5228035843031087, -7.092695371772788],
  [-3.8228028213636556, -7.492694990303061],
  [-4.222804347242562, -7.792694227363608],
  [-3.8228028213636556, -8.292694227363608],
  [-3.3228028213636556, -8.492694990303061],
  [-3.222804347242562, -7.8926946088333345],
  [-2.422803202833382, -7.8926946088333345],
  [-2.722804347242562, -8.392694608833335],
  [-2.1228039657728353, -8.392694608833335],
  [-1.8228028213636556, -9.092693464424155],
  [-2.5228035843031087, -8.992694990303061],
  [-3.0228035843031087, -9.092693464424155],
  [-3.722804347242562, -9.092693464424155],
  [-4.322802821363656, -8.892694608833335],
  [-4.622803965772835, -8.092695371772788],
  [-4.922803202833382, -8.492694990303061],
  [-5.022803584303109, -8.992694990303061],
  [-4.822802821363656, -9.392696516181967],
  [-4.322802821363656, -9.592693464424155],
  [-3.8228028213636556, -9.692695753242514],
  [-3.3228028213636556, -9.792694227363608],
  [-2.722804347242562, -9.792694227363608],
  [-2.222804347242562, -9.792694227363608],
  [-1.8228028213636556, -9.792694227363608],
  [-1.2228043472425618, -9.792694227363608],
  [-1.2228043472425618, -9.192695753242514],
  [-0.9228032028333821, -8.592695371772788],
  [-1.5228035843031087, -8.492694990303061],
  [-1.7228043472425618, -7.992694990303061],
  [-1.9228032028333821, -7.3926946088333345],
];
